'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import Footer8 from '@/components/footers/Footer8'

export default function LayoutFooter({ storeInfo }) {
  const pathname = usePathname()
  const sp = useSearchParams()
  const lineId = sp.get('lineId') || ''
  const from = sp.get('from')
  const CartButtonEnable = storeInfo?.CartButtonEnable

  const isForLine =
    pathname.includes('for_line') ||
    pathname.includes('line/auth') ||
    pathname.includes('barcode') ||
    pathname.includes('royalelastics_image') ||
    from === 'line'

  return (
    <>{!isForLine && CartButtonEnable && <Footer8 storeInfo={storeInfo} />}</>
  )
}
